import React from "react";
import { INavBarIconInterface } from "../Helpers/types";

export default function IconOpenBook(props: INavBarIconInterface) {
  return (
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1 0L17.6 5.85V20.15L24.1 14.3V0ZM7.84995 3.9C5.31495 3.9 2.58495 4.42 0.699951 5.85V24.908C0.699951 25.233 1.02495 25.558 1.34995 25.558C1.47995 25.558 1.54495 25.467 1.67495 25.467C3.42995 24.622 5.96495 24.05 7.84995 24.05C10.385 24.05 13.115 24.57 15 26C16.755 24.895 19.94 24.05 22.15 24.05C24.295 24.05 26.505 24.453 28.325 25.428C28.455 25.493 28.52 25.467 28.65 25.467C28.975 25.467 29.3 25.142 29.3 24.817V5.85C28.52 5.265 27.675 4.875 26.7 4.55V7.15V14.3V22.1C25.27 21.645 23.71 21.45 22.15 21.45C19.94 21.45 16.755 22.295 15 23.4V14.3V8.45V5.85C13.115 4.42 10.385 3.9 7.84995 3.9Z"
        className={props.selected ? "fill-brij-Mud" : "fill-brij-Default"}
      ></path>
    </svg>
  );
}
